import { render, staticRenderFns } from "./SelectProductTag.vue?vue&type=template&id=a904430e&"
import script from "./SelectProductTag.vue?vue&type=script&lang=js&"
export * from "./SelectProductTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports